import React from "react";

import { OrderReleaseSamplesContextProvider } from "./context/order-release-samples-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class OrdersReleaseSamplesPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <OrderReleaseSamplesContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderReleaseSamplesContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OrdersReleaseSamplesPage;
